import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[fpSidebarHost]'
})
export class SidebarHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
